import confetti from 'canvas-confetti';
// Balloons handling: prefer global from CDN, fallback to dynamic import, then custom

// Party mode tracking
let partyModeCounter = 0; // Cycles through 3 party modes: 0=confetti, 1=rainbow, 2=balloons

// Main party mode function with cycling effects
export function activatePartyMode() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const mainTitle = document.getElementById('main-title');
    
    // Cycle through 3 different party modes
    switch(partyModeCounter % 3) {
        case 0: // Professional Confetti Mode
            console.log('🎊 Professional Confetti Party Mode');
            mainTitle?.classList.add('rainbow-text');
            document.body.classList.add('party-background');

            // Professional confetti sequence
            triggerFireworksConfetti();
            setTimeout(() => triggerSideCannonConfetti(), 1000);
            setTimeout(() => triggerStarsConfetti(), 2000);
            setTimeout(() => triggerRandomConfetti(), 3000);

            // Clean up after 8 seconds
            setTimeout(() => {
                mainTitle?.classList.remove('rainbow-text');
                document.body.classList.remove('party-background');
            }, 8000);
            break;

        case 1: // Rainbow Mode (no confetti)
            console.log('🌈 Rainbow Party Mode');
            mainTitle?.classList.add('rainbow-text');
            document.body.classList.add('party-background');

            // Just rainbow effects, no confetti
            setTimeout(() => {
                mainTitle?.classList.remove('rainbow-text');
                document.body.classList.remove('party-background');
            }, 8000);
            break;

        case 2: // Professional Balloon Mode
            console.log('🎈 Professional Balloon Party Mode');
            mainTitle?.classList.add('rainbow-text');
            triggerBalloonsAnimation();

            setTimeout(() => {
                mainTitle?.classList.remove('rainbow-text');
            }, 8000);
            break;
    }
    
    // Increment counter for next activation
    partyModeCounter++;
}

// Helper to safely call confetti (handles CDN load failures)
function safeConfetti(options) {
    if (typeof confetti === 'function') {
        confetti(options);
    }
}

// Professional fireworks confetti effect
function triggerFireworksConfetti() {
    if (typeof confetti !== 'function') return;

    const duration = 3 * 1000;
    const animationEnd = Date.now() + duration;
    const defaults = {
        startVelocity: 30,
        spread: 360,
        ticks: 60,
        zIndex: 0,
        colors: ['#FFE400', '#FFBD00', '#E89400', '#FFCA6C', '#FDFFB8', '#a786ff', '#fd8bbc', '#eca184', '#f8deb1']
    };

    const randomInRange = (min, max) => Math.random() * (max - min) + min;

    const interval = setInterval(() => {
        const timeLeft = animationEnd - Date.now();

        if (timeLeft <= 0) {
            return clearInterval(interval);
        }

        const particleCount = 50 * (timeLeft / duration);

        // Left side firework
        safeConfetti({
            ...defaults,
            particleCount,
            origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 },
        });

        // Right side firework
        safeConfetti({
            ...defaults,
            particleCount,
            origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 },
        });
    }, 250);
}

// Side cannons confetti effect
function triggerSideCannonConfetti() {
    if (typeof confetti !== 'function') return;

    const end = Date.now() + 2 * 1000;
    const colors = ['#a786ff', '#fd8bbc', '#eca184', '#f8deb1'];

    const frame = () => {
        if (Date.now() > end) return;

        safeConfetti({
            particleCount: 2,
            angle: 60,
            spread: 55,
            startVelocity: 60,
            origin: { x: 0, y: 0.5 },
            colors: colors,
        });

        safeConfetti({
            particleCount: 2,
            angle: 120,
            spread: 55,
            startVelocity: 60,
            origin: { x: 1, y: 0.5 },
            colors: colors,
        });

        requestAnimationFrame(frame);
    };

    frame();
}

// Stars confetti effect
function triggerStarsConfetti() {
    if (typeof confetti !== 'function') return;

    const defaults = {
        spread: 360,
        ticks: 50,
        gravity: 0,
        decay: 0.94,
        startVelocity: 30,
        colors: ['#FFE400', '#FFBD00', '#E89400', '#FFCA6C', '#FDFFB8'],
    };

    const shoot = () => {
        safeConfetti({
            ...defaults,
            particleCount: 40,
            scalar: 1.2,
            shapes: ['star'],
        });

        safeConfetti({
            ...defaults,
            particleCount: 10,
            scalar: 0.75,
            shapes: ['circle'],
        });
    };

    setTimeout(shoot, 0);
    setTimeout(shoot, 100);
    setTimeout(shoot, 200);
}

// Random angle confetti for progressive effects
function triggerRandomConfetti() {
    if (typeof confetti !== 'function') return;

    const angle = Math.random() * 360;
    safeConfetti({
        angle: angle,
        spread: 55,
        particleCount: 100,
        origin: { x: 0.5, y: 0.8 },
        colors: ['#FFE400', '#FFBD00', '#E89400', '#FFCA6C', '#FDFFB8', '#a786ff', '#fd8bbc']
    });
}

// Professional balloons animation using balloons-js library
function triggerBalloonsAnimation() {
    // Prefer global (from CDN), otherwise fallback to custom
    if (typeof window !== 'undefined' && typeof window.balloons === 'function') {
        try {
            console.log('🎈 Using balloons-js (global)');
            window.balloons();
            return;
        } catch (e) {
            console.warn('Global balloons() failed, using fallback...', e);
        }
    }
    createProfessionalBalloons();
}

// Professional balloon fallback (if library fails)
function createProfessionalBalloons() {
    const container = document.createElement('div');
    container.className = 'professional-balloons-container';
    container.style.cssText = `
        position: fixed;
        inset: 0;
        z-index: 999;
        pointer-events: none;
        perspective: 1500px;
        perspective-origin: 50vw 100vh;
        overflow: hidden;
    `;
    
    document.body.appendChild(container);
    
    const colorPairs = [
        ['#ffec37', '#f8b13d'], // yellow
        ['#f89640', '#c03940'], // red
        ['#3bc0f0', '#0075bc'], // blue
        ['#b0cb47', '#3d954b'], // green
        ['#cf85b8', '#a3509d'], // purple
    ];
    
    const amount = Math.max(7, Math.round(window.innerWidth / 120));
    
    for (let i = 0; i < amount; i++) {
        const [balloonColor, lightColor] = colorPairs[Math.floor(Math.random() * colorPairs.length)];
        
        const balloon = document.createElement('div');
        balloon.className = 'professional-balloon';
        
        const size = 80 + Math.random() * 40; // Random size 80-120px
        const x = Math.random() * window.innerWidth;
        const z = -Math.random() * 800; // Depth for 3D effect
        const blur = Math.abs(z) / 100; // Blur based on depth for bokeh effect
        
        balloon.style.cssText = `
            position: absolute;
            left: ${x}px;
            top: 100vh;
            width: ${size}px;
            height: ${size}px;
            background: linear-gradient(135deg, ${balloonColor} 0%, ${lightColor} 100%);
            border-radius: 50%;
            transform: translateX(-50%) translateZ(${z}px);
            filter: blur(${blur}px);
            z-index: ${Math.floor(1000 - Math.abs(z))};
            pointer-events: none;
            --z: ${z}px;
            box-shadow: 
                inset -10px -10px 20px rgba(0,0,0,0.3),
                inset 15px 15px 30px rgba(255,255,255,0.6),
                0 10px 30px rgba(0,0,0,0.2);
            animation: professional-balloon-float ${8 + Math.random() * 4}s ease-out forwards;
            animation-delay: ${i * 200}ms;
        `;
        
        // Add balloon highlight
        const highlight = document.createElement('div');
        highlight.style.cssText = `
            position: absolute;
            top: 15%;
            left: 25%;
            width: 25%;
            height: 35%;
            background: radial-gradient(ellipse at center, rgba(255,255,255,0.8) 0%, transparent 70%);
            border-radius: 50%;
            transform: rotate(-25deg);
        `;
        balloon.appendChild(highlight);
        
        // Add balloon string
        const string = document.createElement('div');
        string.style.cssText = `
            position: absolute;
            left: 50%;
            top: 100%;
            width: 2px;
            height: 30px;
            background: linear-gradient(to bottom, #666, #333);
            transform: translateX(-50%);
            border-radius: 1px;
        `;
        balloon.appendChild(string);
        
        container.appendChild(balloon);
    }
    
    // Remove container after animation
    setTimeout(() => container.remove(), 12000);
}
